import React, { useCallback, useState } from 'react';
import queryString from 'query-string';

export type Language = 'zh' | 'en';
export type LanguageParam = Language | 'undefined';

interface ContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const initialContext: ContextValue = {
  language: 'en',
  setLanguage: (lang) => {
    // plz ignore just for init
    console.log(lang);
  },
  t: (value) => value,
};

export const TranslationContext = React.createContext<ContextValue>(initialContext);

const TranslationProvider: React.FC = ({ children }) => {
  const queryParameters = queryString.parse(window.location.hash.split('?')[1] || '');
  const lang = queryParameters.lang as LanguageParam;
  const [language, setLanguage] = useState<Language>(lang && lang !== 'undefined' ? lang : 'en');
  const data = require(`../../../translations/${language}.json`);

  const t = useCallback(
    (key: string) => {
      return key in data ? data[key] : key;
    },
    [data],
  );

  return (
    <TranslationContext.Provider value={{ language: language, setLanguage, t }}>{children}</TranslationContext.Provider>
  );
};

export default TranslationProvider;
